(function(){
  function trackEvent(name, payload) {
    try {
      const dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({ event: name, ...payload });
    } catch (e) {
      console.debug('[trackEvent skipped]', name, payload);
    }
  }
  window.trackEvent = trackEvent;

  document.addEventListener('click',function(e){
    const btn=e.target.closest('[type="submit"][name="add"],.add-to-cart-btn,.product-form__submit');
    if(!btn) return;
    const form=btn.closest('form');
    if(!form || form.getAttribute('method')==='dialog') return;
    
    // 检查按钮是否被禁用
    if(btn.disabled) {
      e.preventDefault();
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    
    // 显示加载状态
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if(spinner) spinner.classList.remove('hidden');
    btn.disabled = true;
    
    const data=new FormData(form);
    const variantId = data.get('id');
    const quantity = parseInt(data.get('quantity')||'1',10);
    
    if(!variantId) {
      console.error('Variant ID not found');
      if(spinner) spinner.classList.add('hidden');
      btn.disabled = false;
      alert('请选择商品选项');
      return;
    }
    
    const body={id:variantId,quantity:quantity};
    
    function refreshCartCount() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const badge = document.querySelector('.cart-count-bubble');
          const countSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span');
          if (badge && countSpan) {
            if (cart.item_count > 0) {
              badge.style.display = '';
              countSpan.textContent = cart.item_count;
            } else {
              badge.style.display = 'none';
            }
          }
        })
        .catch(() => {});
    }
    
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(body)
    })
    .then(r=>{
      if(!r.ok) {
        throw new Error('Add to cart failed');
      }
      return r.json();
    })
    .then(data=>{
      // 显示成功通知
      const n=document.getElementById('cart-notification');
      if(n){
        n.classList.add('is-open');
        setTimeout(()=>n.classList.remove('is-open'),2500);
      }
      
      // 更新购物车图标
      if(window.CartDrawer) {
        const cartDrawer = document.querySelector('cart-drawer');
        if(cartDrawer) {
          cartDrawer.fetchCart();
        }
      }
      refreshCartCount();
      trackEvent('add_to_cart', { id: variantId, quantity: quantity });
    })
    .catch(error=>{
      console.error('Failed to add to cart:',error);
      alert('Add to cart failed, please try again.');
    })
    .finally(()=>{
      if(spinner) spinner.classList.add('hidden');
      btn.disabled = false;
    });
  });
})();

// 搜索提交埋点
(function() {
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/search')) return;
    const query = (form.querySelector('input[name="q"]')?.value || '').trim();
    const type = (form.querySelector('select[name="type"]')?.value || '').trim() || 'all';
    if (!query) return;
    if (typeof trackEvent === 'function') {
      trackEvent('search', { query, type });
    }
  });
})();

// 粘性头部功能
(function() {
  'use strict';
  
  const headerWrapper = document.querySelector('.header-wrapper--sticky[data-sticky-type="on-scroll-up"]');
  if (!headerWrapper) return;
  
  let lastScrollTop = 0;
  let ticking = false;
  const scrollThreshold = 100;
  
  function updateHeader() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > scrollThreshold) {
      headerWrapper.classList.add('header-wrapper--scrolled');
      
      if (scrollTop > lastScrollTop) {
        // 向下滚动 - 隐藏头部
        headerWrapper.classList.add('header-wrapper--hidden');
      } else {
        // 向上滚动 - 显示头部
        headerWrapper.classList.remove('header-wrapper--hidden');
      }
    } else {
      // 在顶部 - 移除所有状态
      headerWrapper.classList.remove('header-wrapper--scrolled', 'header-wrapper--hidden');
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    ticking = false;
  }
  
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  updateHeader(); // 初始检查
})();

// 搜索栏居中布局 - 菜单按钮功能（顶部和底部）
(function() {
  'use strict';
  
  // 顶部菜单按钮（如果存在）
  const topMenuButton = document.querySelector('.header__menu-button[data-menu-toggle]');
  if (topMenuButton) {
    topMenuButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenuDrawer();
    });
  }
  
  // 底部菜单按钮
  const bottomMenuButton = document.querySelector('.header__bottom-menu-button[data-menu-toggle]');
  if (bottomMenuButton) {
    bottomMenuButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenuDrawer();
    });
  }
  
  function toggleMenuDrawer() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) {
      console.error('菜单抽屉未找到');
      return;
    }
    
    // 切换菜单状态
    if (drawer.hasAttribute('open')) {
      drawer.removeAttribute('open');
    } else {
      drawer.setAttribute('open', '');
    }
  }
})();

// 购物车页面交互功能
(function() {
  'use strict';
  
  // 格式化货币
  function formatMoney(cents) {
    return new Intl.NumberFormat('zh-CN', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }
  
  // 更新单个商品的行价格
  function updateLinePrice(line) {
    const input = document.getElementById(`quantity-${line}`);
    if (!input) return;
    
    const quantity = parseInt(input.value, 10) || 0;
    const unitPrice = parseInt(input.getAttribute('data-price'), 10) || 0;
    const linePrice = quantity * unitPrice;
    
    const linePriceElement = input.closest('.cart-item').querySelector('.cart-item__line-price[data-line-price]');
    if (linePriceElement) {
      const originalPrice = linePriceElement.getAttribute('data-line-price');
      const originalLinePrice = parseInt(originalPrice, 10) || 0;
      const originalUnitPrice = originalLinePrice / (parseInt(input.getAttribute('data-original-quantity') || input.value, 10) || 1);
      
      // 更新行价格显示
      linePriceElement.textContent = formatMoney(linePrice);
      linePriceElement.setAttribute('data-line-price', linePrice);
      
      // 如果有原价，也更新原价行价格
      const originalLinePriceElement = input.closest('.cart-item').querySelector('.cart-item__line-price--original');
      if (originalLinePriceElement) {
        const originalLinePriceValue = quantity * originalUnitPrice;
        originalLinePriceElement.textContent = formatMoney(originalLinePriceValue);
        originalLinePriceElement.setAttribute('data-original-line-price', originalLinePriceValue);
      }
    }
  }
  
  // 更新购物车总计
  function updateCartTotal() {
    const cartItems = document.querySelectorAll('.cart-item');
    let subtotal = 0;
    
    cartItems.forEach(item => {
      const input = item.querySelector('.cart-item__quantity-input');
      if (!input) return;
      
      const quantity = parseInt(input.value, 10) || 0;
      const unitPrice = parseInt(input.getAttribute('data-price'), 10) || 0;
      subtotal += quantity * unitPrice;
    });
    
    // 更新小计（第一个cart-summary__row中的value）
    const subtotalRow = document.querySelector('.cart-summary__row:not(.cart-summary__row--total):not(.cart-summary__row--discount)');
    const subtotalElement = subtotalRow?.querySelector('.cart-summary__value');
    
    // 更新总计
    const totalRow = document.querySelector('.cart-summary__row--total');
    const totalElement = totalRow?.querySelector('.cart-summary__value');
    
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(subtotal);
    }
    if (totalElement) {
      totalElement.textContent = formatMoney(subtotal);
    }
  }
  
  // 数量增减按钮
  document.addEventListener('click', function(e) {
    const minusBtn = e.target.closest('.cart-item__quantity-btn--minus');
    const plusBtn = e.target.closest('.cart-item__quantity-btn--plus');
    const removeBtn = e.target.closest('.cart-item__remove');
    
    if (minusBtn || plusBtn) {
      e.preventDefault();
      const line = minusBtn ? minusBtn.getAttribute('data-line') : plusBtn.getAttribute('data-line');
      const input = document.getElementById(`quantity-${line}`);
      if (!input) return;
      
      let currentValue = parseInt(input.value, 10) || 0;
      if (minusBtn && currentValue > 0) {
        currentValue--;
      } else if (plusBtn) {
        currentValue++;
      }
      
      input.value = currentValue;
      updateLinePrice(line);
      updateCartTotal();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const line = parseInt(removeBtn.getAttribute('data-line'), 10);
      const cartItem = removeBtn.closest('.cart-item');
      
      if (!line || isNaN(line)) {
        console.error('无效的商品行号');
        return;
      }
      
      // 禁用按钮防止重复点击
      removeBtn.disabled = true;
      removeBtn.style.opacity = '0.5';
      removeBtn.style.pointerEvents = 'none';
      
      // 使用Shopify API直接删除商品
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: 0
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('删除失败');
        }
        return response.json();
      })
      .then(cart => {
        // 重新加载页面以更新购物车
        window.location.reload();
      })
      .catch(error => {
        console.error('删除商品失败:', error);
        // 恢复按钮状态
        removeBtn.disabled = false;
        removeBtn.style.opacity = '1';
        removeBtn.style.pointerEvents = 'auto';
        
        // 如果API失败，尝试使用表单提交方式
        const input = document.getElementById(`quantity-${line}`);
        if (input) {
          input.value = 0;
          const form = document.getElementById('cart');
          if (form) {
            // 使用表单提交方式
            form.submit();
          }
        }
      });
    }
  });
  
  // 数量输入框变化时更新价格
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('cart-item__quantity-input')) {
      const line = e.target.getAttribute('data-line');
      let quantity = parseInt(e.target.value, 10);
      
      // 确保数量不为负数
      if (isNaN(quantity) || quantity < 0) {
        quantity = 0;
        e.target.value = 0;
      }
      
      // 如果数量为0，自动触发删除
      if (quantity === 0) {
        const cartItem = e.target.closest('.cart-item');
        const removeBtn = cartItem?.querySelector('.cart-item__remove');
        if (removeBtn) {
          removeBtn.click();
          return;
        }
      }
      
      updateLinePrice(line);
      updateCartTotal();
    }
  });
  
  // 初始化：保存原始数量并设置价格数据
  function initCartPrices() {
    const inputs = document.querySelectorAll('.cart-item__quantity-input');
    inputs.forEach(input => {
      const line = input.getAttribute('data-line');
      const cartItem = input.closest('.cart-item');
      
      // 如果已经有data-price属性（从模板设置），直接使用
      let unitPrice = parseInt(input.getAttribute('data-price'), 10);
      
      // 如果没有，从行价格计算
      if (!unitPrice || isNaN(unitPrice)) {
        const linePriceElement = cartItem.querySelector('.cart-item__line-price[data-line-price]');
        if (linePriceElement) {
          const currentLinePrice = parseInt(linePriceElement.getAttribute('data-line-price'), 10) || 0;
          const currentQuantity = parseInt(input.value, 10) || 1;
          unitPrice = currentLinePrice / currentQuantity;
          input.setAttribute('data-price', unitPrice);
        }
      }
      
      // 保存原始数量
      const currentQuantity = parseInt(input.value, 10) || 1;
      input.setAttribute('data-original-quantity', currentQuantity);
    });
  }
  
  // 页面加载时初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPrices);
  } else {
    initCartPrices();
  }
})();

// 心愿单功能 - 全局
(function() {
  'use strict';
  
  const WISHLIST_STORAGE_KEY = 'shopify_wishlist';
  
  // 更新心愿单数量显示
  function updateWishlistCount() {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      const items = wishlist ? JSON.parse(wishlist) : [];
      const count = items.length;
      const countElement = document.getElementById('wishlist-count-badge');
      if (countElement) {
        countElement.textContent = count;
        countElement.style.display = count > 0 ? 'flex' : 'none';
      }
    } catch (e) {
      console.error('更新心愿单数量失败:', e);
    }
  }
  
  // 添加到心愿单
  function addToWishlist(product) {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      const items = wishlist ? JSON.parse(wishlist) : [];
      
      // 检查是否已存在
      if (items.find(item => item.id === product.id)) {
        return false;
      }
      
      items.push(product);
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
      updateWishlistCount();
      return true;
    } catch (e) {
      console.error('添加到心愿单失败:', e);
      return false;
    }
  }
  
  // 从心愿单移除
  function removeFromWishlist(productId) {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      const items = wishlist ? JSON.parse(wishlist) : [];
      const filtered = items.filter(item => item.id !== productId);
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(filtered));
      updateWishlistCount();
      return true;
    } catch (e) {
      console.error('从心愿单移除失败:', e);
      return false;
    }
  }
  
  // 检查是否在心愿单中
  function isInWishlist(productId) {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      const items = wishlist ? JSON.parse(wishlist) : [];
      return items.some(item => item.id === productId);
    } catch (e) {
      return false;
    }
  }
  
  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistCount);
  } else {
    updateWishlistCount();
  }
  
  // 暴露全局API
  window.WishlistAPI = {
    add: addToWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    updateCount: updateWishlistCount
  };
  
  // 监听存储变化（跨标签页同步）
  window.addEventListener('storage', function(e) {
    if (e.key === WISHLIST_STORAGE_KEY) {
      updateWishlistCount();
    }
  });
})();

// 专业菜单系统 - 侧边菜单交互
(function() {
  'use strict';
  
  const menuTriggers = document.querySelectorAll('.menu-drawer__menu-item[data-menu-trigger]');
  const submenuPanels = document.querySelectorAll('.menu-drawer__submenu-panel');
  
  if (menuTriggers.length === 0) return;
  
  // 关闭所有子菜单
  function closeAllSubmenus() {
    submenuPanels.forEach(panel => {
      panel.classList.remove('is-active');
    });
    menuTriggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('menu-drawer__menu-item--active');
    });
  }
  
  // 打开指定子菜单
  function openSubmenu(index) {
    closeAllSubmenus();
    const panel = document.querySelector(`.menu-drawer__submenu-panel[data-submenu="${index}"]`);
    const trigger = document.querySelector(`.menu-drawer__menu-item[data-menu-trigger="${index}"]`);
    
    if (panel && trigger) {
      panel.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('menu-drawer__menu-item--active');
    }
  }
  
  // 为每个菜单项添加点击事件
  menuTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const index = this.getAttribute('data-menu-trigger');
      const isActive = this.classList.contains('menu-drawer__menu-item--active');
      
      if (isActive) {
        closeAllSubmenus();
      } else {
        openSubmenu(index);
      }
    });
  });
  
  // 关闭按钮功能 - 使用多种方法确保能正常工作
  function closeMenuDrawer() {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (drawer) {
      // 强制关闭 details 元素
      drawer.open = false;
      drawer.removeAttribute('open');
      // 确保CSS状态也更新
      drawer.classList.remove('open');
      closeAllSubmenus();
    }
  }
  
  // 阻止 summary 的默认行为，使用自定义逻辑
  const summary = document.querySelector('.header__navigation-menu-button');
  if (summary) {
    summary.addEventListener('click', function(e) {
      const drawer = this.closest('details');
      if (drawer) {
        // 如果抽屉已经打开，不执行默认行为
        if (drawer.open) {
          // 允许默认行为（关闭）
        } else {
          // 打开抽屉
          drawer.open = true;
          drawer.setAttribute('open', '');
        }
      }
    });
  }
  
  // 关闭按钮事件处理 - 使用多种方法确保能工作
  function handleCloseButtonClick(e) {
    const closeBtn = e.target.closest('.menu-drawer__close-btn');
    if (!closeBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // 找到 details 元素并关闭
    const drawer = closeBtn.closest('details#Details-menu-drawer-container');
    if (drawer) {
      drawer.open = false;
      drawer.removeAttribute('open');
      drawer.classList.remove('open');
    }
    
    closeAllSubmenus();
    return false;
  }
  
  // 方法1: 事件委托（捕获阶段）
  document.addEventListener('click', handleCloseButtonClick, true);
  
  // 方法2: 事件委托（冒泡阶段，作为备用）
  document.addEventListener('click', handleCloseButtonClick, false);
  
  // 方法3: 直接为所有关闭按钮添加事件监听器
  function attachCloseButtonListeners() {
    const closeButtons = document.querySelectorAll('.menu-drawer__close-btn');
    closeButtons.forEach(function(btn) {
      // 移除旧的事件监听器
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      // 添加新的事件监听器
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const drawer = this.closest('details#Details-menu-drawer-container');
        if (drawer) {
          drawer.open = false;
          drawer.removeAttribute('open');
        }
        closeAllSubmenus();
        return false;
      }, true);
    });
  }
  
  // 页面加载时设置
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachCloseButtonListeners);
  } else {
    attachCloseButtonListeners();
  }
  
  // 当菜单打开时，确保关闭按钮可用
  const drawer = document.querySelector('#Details-menu-drawer-container');
  if (drawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          // 菜单状态改变时，确保关闭按钮可用
          const closeBtn = drawer.querySelector('.menu-drawer__close-btn');
          if (closeBtn && drawer.open) {
            // 确保关闭按钮可以点击
            closeBtn.style.pointerEvents = 'auto';
            closeBtn.style.zIndex = '1000';
          }
        }
      });
    });
    
    observer.observe(drawer, { 
      attributes: true,
      attributeFilter: ['open']
    });
  }
  
  // 点击遮罩层关闭菜单 - 使用事件委托
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('menu-drawer__overlay')) {
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer) {
        drawer.open = false;
        drawer.removeAttribute('open');
        closeAllSubmenus();
      }
    }
  });
  
  // 点击外部关闭菜单
  document.addEventListener('click', function(e) {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer || !drawer.open) return;
    
    // 如果点击的是打开按钮（summary），不关闭
    if (e.target.closest('summary.header__navigation-menu-button') ||
        e.target.closest('.header__menu-button')) {
      return;
    }
    
    // 如果点击的是菜单内部，不关闭
    const isClickInside = drawer.contains(e.target) || 
                         e.target.closest('.menu-drawer__inner-container');
    
    if (!isClickInside) {
      drawer.open = false;
      drawer.removeAttribute('open');
      closeAllSubmenus();
    }
  });
})();



